import { render, staticRenderFns } from "./NotificationsFiltersModal.vue?vue&type=template&id=608a678c&"
import script from "./NotificationsFiltersModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsFiltersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports